<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-08 10:46:28
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-12-27 15:32:51
 * @FilePath: /wemeet-admin-new/src/views/exhibitionManage/components/matchingDetail.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer userInfoDrawer"
    :direction="direction"
    :size="size"
  >
    <div class="containerForm">
      <el-descriptions border class="margin-top" direction="vertical" title="基础信息">
        <el-descriptions-item label="供需类型">
          <h3>{{ handleGxType() }}</h3>
        </el-descriptions-item>
        <el-descriptions-item label="服务类型">
          <h3>{{ detail.industry ? detail.industry : '/' }}</h3>
        </el-descriptions-item>
        <el-descriptions-item label="发布时间">
          <h3>{{ handleDate(detail.publishTime) }}</h3>
        </el-descriptions-item>
        <el-descriptions-item label="标题">
          <h3>{{ detail.title ? detail.title : '/' }}</h3>
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions
        v-if="detail.userFillSdFormDetailDtoList.length > 0"
        border
        class="margin-top"
        :column="1"
        title="发布时填写信息"
      >
        <template v-for="(item, index) in detail.userFillSdFormDetailDtoList" :key="index">
          <el-descriptions-item
            v-if="item.type != 'FILEUPLOAD' && item.type != 'AREA' && item.type != 'IMGUPLOAD'"
            :label="item.formTitle"
          >
            {{ item.formContent ? item.formContent : '/' }}
          </el-descriptions-item>

          <el-descriptions-item v-if="item.type == 'FILEUPLOAD'" :label="item.formTitle">
            <a href="javascript:;" @click="downloadFile(item.formContent)">{{ item.formContent.fileName }}</a>
          </el-descriptions-item>
          <el-descriptions-item v-if="item.type == 'AREA'" :label="item.formTitle">
            {{ item.formContent.country ? item.formContent.country : '/' }}
            {{ item.formContent.province ? item.formContent.province : '' }}
            {{ item.formContent.city ? item.formContent.city : '' }}
            {{ item.formContent.area ? item.formContent.area : '' }}
          </el-descriptions-item>

          <el-descriptions-item v-if="item.type == 'IMGUPLOAD'" :label="item.formTitle">
            <el-image
              v-if="item.formContent"
              fit="cover"
              :initial-index="4"
              :max-scale="7"
              :min-scale="0.2"
              :preview-src-list="[item.formContent]"
              :src="item.formContent"
              style="width: 100px; height: 100px"
              :zoom-rate="1.2"
            />
            <span v-else>/</span>
          </el-descriptions-item>
        </template>
      </el-descriptions>
      <el-alert
        v-if="detail.safetyTips"
        :description="detail.safetyTips"
        style="margin-top: 20px"
        title="安全提示"
        type="error"
      />
    </div>
    <div v-if="type == 'edit'" class="demo-drawer__footer">
      <el-button
        v-if="detail.status == 'PENDING' || detail.status == 'NO_PASS'"
        type="primary"
        @click="dialogFormVisible2 = true"
      >
        通过
      </el-button>
      <el-button
        v-if="detail.status == 'PENDING' || detail.status == 'PASS'"
        type="danger"
        @click="dialogFormVisible1 = true"
      >
        不通过
      </el-button>
    </div>

    <el-drawer ref="drawerRef" v-model="dialogFormVisible1" :append-to-body="true" :size="size1" title="审核不通过">
      <el-form ref="reasonRef" :model="form" :rules="rules">
        <el-alert effect="dark" title="请确认该内容发布审核不通过，并留言说明理由" type="error" />
        <el-form-item label="留言" prop="reason">
          <el-input v-model="form.reason" maxlength="100" show-word-limit type="textarea" />
        </el-form-item>
        <el-form-item align="center">
          <el-button size="large" type="primary" @click="refuse">提交</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>

    <el-drawer ref="drawerRef" v-model="dialogFormVisible2" :append-to-body="true" :size="size1" title="审核通过">
      <el-alert description="请确认该内容发布审核通过" effect="dark" type="info" />
      <el-form ref="reasonRef" :model="form">
        <el-form-item label="留言" prop="reason">
          <el-input v-model="form.reason" maxlength="100" show-word-limit type="textarea" />
        </el-form-item>
        <el-form-item align="center">
          <el-button size="large" type="primary" @click="accept">提交</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </el-drawer>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
  import { getSdDetail, sdBatchAudit } from '@/api/exhibitionManage'
  import { parseTime } from '@/utils/index'
  export default defineComponent({
    name: 'UserDetail',
    props: {
      meetingCode: {
        type: String,
        default: '',
      },
    },
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()
      const state = reactive({
        dialogFormVisible: false,
        dialogFormVisible1: false,
        dialogFormVisible2: false,
        direction: 'rtl',
        size: '50%',
        size1: '30%',
        detail: {
          userFillSdFormDetailDtoList: [],
        },
        rules: {
          reason: [
            {
              required: true,
              message: '请填写留言',
              trigger: 'blur',
            },
          ],
        },
        statusList: {
          PENDING_REVIEW: '待审核',
          ACCEPT: `审核通过`,
          REFUSE: '审核不通过',
          CANCEL_SIGN: `取消报名`,
          NOT_REVIEW: `无需审核`,
        },
        form: {
          reason: '',
        },
        userTypeList: [
          {
            name: '待审核',
            key: 'PENDING',
          },
          {
            name: '已发布',
            key: 'PASS',
          },
          {
            name: '已取消',
            key: 'CANCEL',
          },
          {
            name: '审核不通过',
            key: 'NO_PASS',
          },
        ],
        gxList: [
          {
            name: '全部',
            key: '',
          },
          {
            name: '需求',
            key: 'DEMAND',
          },
          {
            name: '供应',
            key: 'SUPPLY',
          },
        ],
        meetingCode: '',
        reasonRef: null,
        type: '',
      })
      // 打开
      const handleOpen = async (row, meetingCode, type = 'edit') => {
        console.log(type)
        state.row = row
        state.dialogFormVisible = true
        state.type = type
        state.userSdFormCode = row.userSdFormCode
        state.meetingCode = meetingCode
        const { data } = await getSdDetail({
          fillFormCode: row.userSdFormCode,
          meetingCode,
        })
        if (data.userFillSdFormDetailDtoList) {
          data.userFillSdFormDetailDtoList.forEach((item) => {
            if (item.type == 'FILEUPLOAD' || item.type == 'AREA') {
              item.formContent = item.formContent ? JSON.parse(item.formContent) : {}
            }
          })
        }
        state.detail = data
      }
      // 关闭
      const handleClose = () => {
        state.dialogFormVisible = false
        state.dialogFormVisible1 = false
        state.dialogFormVisible2 = false
      }

      const refuse = async () => {
        state['reasonRef'].validate(async (valid) => {
          if (valid) {
            try {
              let parmas = {
                reason: state.form.reason,
                status: 'NO_PASS',
                codes: [state.userSdFormCode],
                type: 'PUBLISH_FORM',
                meetingCode: state.meetingCode,
              }
              const { data } = await sdBatchAudit(parmas)
              proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            } catch (err) {
              console.log(err)
              proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
            }
            emit('fetch-data')
            handleClose()
          }
        })
      }
      const accept = async () => {
        try {
          let parmas = {
            reason: state.form.reason,
            status: 'PASS',
            codes: [state.userSdFormCode],
            type: 'PUBLISH_FORM',
            meetingCode: state.meetingCode,
          }
          const { data } = await sdBatchAudit(parmas)
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
        } catch (err) {
          proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
        }
        emit('fetch-data')
        handleClose()
      }
      const handleGxType = () => {
        let checkItem = state.gxList.filter((v) => v.key == state.detail.sdType)
        if (checkItem.length > 0) {
          return checkItem[0].name
        } else {
          return '暂无数据'
        }
      }

      const handleStatus = (row) => {
        let checkItem = state.userTypeList.filter((v) => v.key == state.detail.status)
        if (checkItem.length > 0) {
          return checkItem[0].name
        } else {
          return '暂无数据'
        }
      }

      const handleDate = (val) => {
        return parseTime(val)
      }

      const downloadFile = (row) => {
        getBlob(row.fileUrl).then((blob) => {
          let a = document.createElement('a')
          let url = window.URL.createObjectURL(blob)
          a.setAttribute('href', url)
          a.setAttribute('target', '_blank')
          a.setAttribute('download', row.fileName)
          document.body.appendChild(a)
          a.click()
          a.remove()
          window.URL.revokeObjectURL(url)
        })
      }

      const getBlob = (url) => {
        return new Promise((resolve) => {
          const xhr = new XMLHttpRequest()
          xhr.open('GET', url, true)
          xhr.responseType = 'blob'
          xhr.onload = () => {
            if (xhr.status === 200) {
              resolve(xhr.response)
            }
          }
          xhr.send()
        })
      }
      return {
        ...toRefs(state),
        handleOpen,
        handleClose,
        refuse,
        accept,
        handleStatus,
        handleGxType,
        handleDate,
        downloadFile,
      }
    },
  })
</script>

<style lang="scss">
  .userInfoDrawer {
    .el-transfer-panel {
      width: 250px;
    }
    .hideLabel {
      .el-descriptions__label {
        display: none;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }
  .containerForm {
    height: 85vh;
    overflow-y: auto;
  }
  .demo-drawer__footer {
    position: fixed;
    right: 20px;
    bottom: 10px;
  }
  .margin-top {
    margin-top: 20px;
  }
</style>
